import React, { Component } from 'react';
import LeftNav from '../../../components/toolbars/LeftNav';

export default
class ProjectSettingsContainer extends Component {
  render() {
    return (
      <div className="row" style={{ flex: 1 }}>
        <LeftNav
          navType="settings"
          {...this.props}
        />
        <div className="col-md-10 flex-row">
          {this.props.children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/Settings/Settings.js